"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const shared_1 = require("./shared");
async function getFeatureFlag(accessToken, correlationId, flagId, locationId) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/flags/${flagId}/locations/${locationId}`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    })).data;
    return result.value;
}
exports.getFeatureFlag = getFeatureFlag;
async function getLocationsByFlag(accessToken, correlationId, flagId) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/flags/${flagId}/locations`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    })).data;
    return result.items;
}
exports.getLocationsByFlag = getLocationsByFlag;
async function putFeatureFlag(accessToken, correlationId, flagId, locationId, value, etag) {
    const headers = Object.assign(Object.assign({}, shared_1.getHeaders(accessToken, correlationId)), (etag && { 'if-match': etag }));
    const result = await axios_1.default.put(`${shared_1.getBaseUrl()}/v0/flags/${flagId}/locations/${locationId}`, { value }, {
        headers,
    });
    return result.headers.ETag;
}
exports.putFeatureFlag = putFeatureFlag;
async function deleteFeatureFlag(accessToken, correlationId, flagId, locationId) {
    await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/flags/${flagId}/locations/${locationId}`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    });
}
exports.deleteFeatureFlag = deleteFeatureFlag;
//# sourceMappingURL=feature-flags.v0.js.map